interface StarT {
    stars: number;
    fixStar: number;
}

export default function FixStar({ stars, fixStar }: StarT) {
    const sArr = Array(stars).fill(0);
    return (
        <form className="form-result">
            <div className="form-rating-result">
                <div className="form-rating__stars-result">
                    <ul className="form-rating__list-result">
                        {sArr.map((s, i) => (
                            <li key={i} className="form-rating__item-result">
                                <div
                                    className={`${(fixStar) > i ? 'star-result-full' : 'star-result-empty'}`}
                                ></div>
                            </li>
                        ))}

                    </ul>
                </div>
            </div>
        </form>
    )
}